import { Navigate, Route, BrowserRouter, Routes, useLocation } from 'react-router-dom'

import { AppLayout } from './app-layout'
import { AnonymousOnlyRoute, ProtectedRoute } from './auth-routes'
import { AuthProvider } from './auth-provider'
import { AccountProvider } from './account-provider'
import { AccountSettingsPage } from '@/features/account-settings/account-settings-page'
import { ActivitiesPage } from '@/features/activities/activities-page'
import { ForgotPasswordPage } from '@/features/auth/forgot-password-page'
import { ClaimProfilePage } from '@/features/auth/claim-profile-page'
import { LoginPage } from '@/features/auth/login-page'
import { ResetPasswordPage } from '@/features/auth/reset-password-page'
import { CompanyDetailPage } from '@/features/companies/company-detail-page'
import { JobDetailPage } from '@/features/jobs/job-detail-page'
import { JobSearchPage } from '@/features/jobs/job-search-page'
import { JobsPage } from '@/features/jobs/jobs-page'
import { OnboardingPage } from '@/features/onboarding/onboarding-page'
import { ProfilePage } from '@/features/profile/profile-page'
import { StaticInfoPage } from '@/features/support/static-info-page'
import { NotFoundPage } from '@/features/support/not-found-page'

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AccountProvider>
            <Routes>
              <Route element={<AnonymousOnlyRoute />}>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              </Route>
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/claim/:token" element={<ClaimProfilePage />} />
              <Route path="/apply" element={<OnboardingPage />} />
              <Route path="/apply-job" element={<OnboardingPage />} />
              <Route path="/privacy" element={<StaticInfoPage kind="privacy" />} />
              <Route path="/terms" element={<StaticInfoPage kind="terms" />} />
              <Route path="/help" element={<StaticInfoPage kind="help" />} />
              {/* Legacy's three registration entrances. They rendered a help PLACEHOLDER here —
                  every campaign link and old bookmark landed on a dead end while the real
                  registration lived at /apply. Redirect, and keep the query string: /reg links
                  in the wild carry job_slug and campaign parameters the wizard consumes. */}
              <Route path="/signup" element={<RedirectToApply />} />
              <Route path="/lp/register" element={<RedirectToApply />} />
              <Route path="/reg" element={<RedirectToApply />} />

              <Route element={<ProtectedRoute />}>
                <Route path="/onboarding" element={<OnboardingPage />} />
                <Route element={<AppLayout />}>
                  <Route index element={<Navigate to="/jobs" replace />} />
                  <Route path="/jobs" element={<JobsPage />} />
                  <Route path="/job-search" element={<JobSearchPage />} />
                  <Route path="/job/:jobSlug" element={<JobDetailPage />} />
                  <Route path="/company/:companySlug" element={<CompanyDetailPage />} />
                  <Route path="/my-profile" element={<ProfilePage />} />
                  <Route path="/activities" element={<ActivitiesPage />} />
                  <Route path="/account-settings" element={<AccountSettingsPage />} />
                </Route>
              </Route>

              <Route path="*" element={<NotFoundPage />} />
            </Routes>
        </AccountProvider>
      </AuthProvider>
    </BrowserRouter>
  )
}

function RedirectToApply() {
  const location = useLocation()
  return <Navigate to={`/apply${location.search}`} replace />
}
